import styles from "../../styles/Videos/video.module.css";
import browsevideosstyles from "../../styles/BrowseVideos/BrowseVideos.module.css";
import "../../styles/Videos/video.css";
import VideoCategories from "./VideoCategories";
import Videos from "./Videos";
import { useEffect, useState } from "react";
import PremiumCourseBanner from "./PremiumCourseBanner";
import { useMediaQuery } from "react-responsive";
import MobileVideoCategory from "./Mobile/MobileVideoCategory";

const videosList = [
  {
    thumbnailUrl:
      "https://i.ytimg.com/vi/saSuovTdS5E/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAPybMGbcDs_ALYrvrKRbGpi-j2-w",
    title: "Fight Your Fear Of Public Speaking Part 1",
    src: "https://www.youtube.com/embed/saSuovTdS5E?si=BLPp6r7k98DW0390",
  },
  {
    thumbnailUrl:
      "https://i.ytimg.com/vi/7o-VYbCiBCI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLD6S3_QMzXflP5vf4UABTqX2k3M5A",
    title: "Know The 18 Key Qualities Of Successful Entrepreneurs Part 1",
    src: "https://www.youtube.com/embed/7o-VYbCiBCI?si=sQ5JAm3XoewdTPxj",
  },
  {
    thumbnailUrl:
      "https://i.ytimg.com/vi/CwfXs4XuYvI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBf5nAYBC7mqxuvS6RIoeYGAN4BLQ",
    title: "Mastering The Art Of Copywriting",
    src: "https://www.youtube.com/embed/CwfXs4XuYvI?si=DGiebfAEIpPOKQDK",
  },
  {
    thumbnailUrl:
      "https://i.ytimg.com/vi/1GYiA550Iqg/hqdefault.jpg?sqp=-oaymwEnCPYBEIoBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBb7Tb4uxHFuXWuXYOBXwwKPNaL4A",
    title: "How To Read A Book",
    src: "https://www.youtube.com/embed/1GYiA550Iqg?si=swIsc-3P7N9EEI92",
  },
  {
    thumbnailUrl: "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
    title: "MindMaps - Part 1",
    src: "https://www.youtube.com/embed/1_eOArOBwiM?si=fTg7rfdh9w68Y1E_",
  },
];

const playLists = {
  1: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/saSuovTdS5E/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAPybMGbcDs_ALYrvrKRbGpi-j2-w",
      title: "Fight Your Fear Of Public Speaking Part 1",
      src: "https://www.youtube.com/embed/saSuovTdS5E?si=BLPp6r7k98DW0390",
      countViews: 8,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/VDD0zH_5y_I/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAKIbW07gDp3j_3AxMTQwBWkBaACg",
      title: "Fight Your Fear Of Public Speaking Part 2",
      src: "https://www.youtube.com/embed/VDD0zH_5y_I?si=GpHBrruiV6uQUfWk",
      countViews: 10,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/9GqCVQEtQg4/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLD0MdgYGgNS06w8LE8Jp-G9-Ei3jA",
      title: "Fight Your Fear Of Public Speaking Part 4",
      src: "https://www.youtube.com/embed/9GqCVQEtQg4?si=4bsM8mIhGaCatu5n",
      countViews: 9,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/rLemoW3iPTY/hqdefault.jpg?sqp=-oaymwEnCNACELwBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDvdkpdw6QG10J-QKl8INRPm-LTcw",
      title: "Fight Your Fear Of Public Speaking Part 5",
      src: "https://www.youtube.com/embed/rLemoW3iPTY?si=GgcmrA-UFaEeR_DM",
      countViews: 12,
    },
  ],
  2: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/7o-VYbCiBCI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLD6S3_QMzXflP5vf4UABTqX2k3M5A",
      title: "Know The 18 Key Qualities Of Successful Entrepreneurs Part 1",
      src: "https://www.youtube.com/embed/7o-VYbCiBCI?si=sQ5JAm3XoewdTPxj",
      countViews: 13,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/-j18OmFNhe8/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCbNdE0yTPyEiOhFK3SyNMSbUdQlw",
      title: "Know The 18 Key Qualities Of Successful Entrepreneurs Part 2",
      src: "https://www.youtube.com/embed/-j18OmFNhe8?si=HRu9VUq7XEQagzuM",
      countViews: 12,
    },
  ],
  3: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/CwfXs4XuYvI/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBf5nAYBC7mqxuvS6RIoeYGAN4BLQ",
      title: "Mastering The Art Of Copywriting",
      src: "https://www.youtube.com/embed/CwfXs4XuYvI?si=DGiebfAEIpPOKQDK",
      countViews: 14,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/OEoWIw-dQuk/hqdefault.jpg?sqp=-oaymwEnCPYBEIoBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCPRnIpuQCCf_Aobg_PX5vZJGPqeQ",
      title:
        "The Game-Changer: Unveiling The Importance Of Writing Effective Headlines",
      src: "https://www.youtube.com/embed/OEoWIw-dQuk?si=f0e8UdaOUPGWuTvX",
      countViews: 20,
    },
  ],
  4: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/1GYiA550Iqg/hqdefault.jpg?sqp=-oaymwEnCPYBEIoBSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBb7Tb4uxHFuXWuXYOBXwwKPNaL4A",
      title: "How To Read A Book",
      src: "https://www.youtube.com/embed/1GYiA550Iqg?si=swIsc-3P7N9EEI92",
      countViews: 17,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi/O0HBuRiaxn8/hqdefault.jpg?sqp=-oaymwFBCPYBEIoBSFryq4qpAzMIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB8AEB-AHOBYACgAqKAgwIABABGGUgVihFMA8=&rs=AOn4CLD_mDLGIT5HM-x_jb0wiEs27C-nfQ",
      title: "Books You Can Give A Read If You Haven't Yet",
      src: "https://www.youtube.com/embed/O0HBuRiaxn8?si=8upbjOxJ9A1nzIXQ",
      countViews: 67,
    },
  ],
  5: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
      title: "MindMaps - Part 1",
      src: "https://www.youtube.com/embed/1_eOArOBwiM?si=fTg7rfdh9w68Y1E_",
      countViews: 23,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
      title: "MindMaps - Part 2",
      src: "https://www.youtube.com/embed/Ki6GpT7wnm0?si=eR-fpt4Ph5JJ6yM6",
      countViews: 14,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
      title: "MindMaps - Part 3",
      src: "https://www.youtube.com/embed/iEMRs-9Cjf0?si=1eNQLvblKvn-VmDc",
      countViews: 67,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/1_eOArOBwiM/maxresdefault.webp",
      title: "MindMaps - Part 4",
      src: "https://www.youtube.com/embed/F-YjfesEM8g?si=W55vG1RLT95RuhIF",
      countViews: 42,
    },
  ],
  6: [
    {
      thumbnailUrl: "https://i.ytimg.com/vi/JUZ2XY1d4Bc/maxresdefault.jpg",
      title: "80-20 Rule - Pareto's Principle ",
      src: "https://www.youtube.com/embed/JUZ2XY1d4Bc?si=q2Al6Ua_5y_6E4sl",
      countViews: 90,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/bPOMUzhUp5g/maxresdefault.jpg",
      title: "What Is Simplicity - Part 1",
      src: "https://www.youtube.com/embed/bPOMUzhUp5g?si=HHt7yLCDLS3cjSzP",
      countViews: 39,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/wQdobPu4vlc/maxresdefault.jpg",
      title: "What Is Simplicity - Part 2",
      src: "https://www.youtube.com/embed/wQdobPu4vlc?si=LyB_3QWDJsP6D1Ap",
      countViews: 26,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/1FU4L3mE_44/maxresdefault.jpg",
      title: "What Is Simplicity - Part 3",
      src: "https://www.youtube.com/embed/1FU4L3mE_44?si=1sKm2wCamLbwH_Rs",
      countViews: 22,
    },
  ],
  7: [
    {
      thumbnailUrl: "https://i.ytimg.com/vi/DFeWLCt91sI/maxresdefault.jpg",
      title: "Storytelling With Data",
      src: "https://www.youtube.com/embed/DFeWLCt91sI?si=MYEy7uZR88ajMOUI",
      countViews: 40,
    },
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/uq9wPr5LF5I/maxresdefault.webp",
      title: "How To Write A Perfect Email",
      src: "https://www.youtube.com/embed/uq9wPr5LF5I?si=1OiOzSmQ2cnTFQPA",
      countViews: 23,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/YB_bA2OjKno/maxresdefault.jpg",
      title: "Learn to organize your Presentation like a pro",
      src: "https://www.youtube.com/embed/YB_bA2OjKno?si=DtRZHCTzYejt5Woc",
      countViews: 20,
    },
  ],
  8: [
    {
      thumbnailUrl: "https://i.ytimg.com/vi/Y2q076z7ZUs/maxresdefault.jpg",
      title: "The Hooked Model",
      src: "https://www.youtube.com/embed/Y2q076z7ZUs?si=r7O8FpxOSWRQ9GnT",
      countViews: 48,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/MvTE5kGJVKk/maxresdefault.jpg",
      title: "USP - Universal Selling Proposition",
      src: "https://www.youtube.com/embed/MvTE5kGJVKk?si=bzDYkb_bLGZsKHTZ",
      countViews: 15,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/VO7cvvZDKz8/maxresdefault.jpg",
      title: "The 22 Laws Of Marketing - Part 1",
      src: "https://www.youtube.com/embed/VO7cvvZDKz8?si=l_tQPqEDD4p5ECVI",
      countViews: 15,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/g3RNk-PqRNU/maxresdefault.jpg",
      title: "The 22 Laws Of Marketing - Part 2",
      src: "https://www.youtube.com/embed/g3RNk-PqRNU?si=PZWT19P-8h2CTppi",
      countViews: 20,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi_webp/SrZ3vwLpQ0A/maxresdefault.webp",
      title: "Customer Development - Part 1",
      src: "https://www.youtube.com/embed/SrZ3vwLpQ0A?si=yISUYxNVRhpzOAu2",
      countViews: 15,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/LnpZ9wr-Yxo/maxresdefault.jpg",
      title: "Customer Development - Part 2",
      src: "https://www.youtube.com/embed/LnpZ9wr-Yxo?si=QEBUijpT27PDY9t5",
      countViews: 24,
    },
    {
      thumbnailUrl: "https://i.ytimg.com/vi/LnpZ9wr-Yxo/maxresdefault.jpg",
      title: "Customer Development - Part 2",
      src: "https://www.youtube.com/embed/LnpZ9wr-Yxo?si=QEBUijpT27PDY9t5",
      countViews: 24,
    },
  ],
  9: [
    {
      thumbnailUrl: "https://i.ytimg.com/vi/KjDzpfS6y3w/maxresdefault.jpg",
      title: "Creative Thinking Workshop - Part 1",
      src: "https://www.youtube.com/embed/KjDzpfS6y3w?si=myinE0o0ErLAIXRM",
      countViews: 262,
    },
  ],
  10: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/CSxnnzwssFo/maxresdefault.webp",
      title: "Attitude Is Everything - Part 1",
      src: "https://www.youtube.com/embed/CSxnnzwssFo?si=khF5csgqEvJ7iAM1",
      countViews: 30,
    },
  ],
  11: [
    {
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/eY4W3AQ3K7M/maxresdefault.webp",
      title: "Effective Time Management Techniques For Success",
      src: "https://www.youtube.com/embed/eY4W3AQ3K7M?si=PyVxqnFAkMYoclZv",
      countViews: 19,
    },
  ],
};
const Video = () => {
  const [videos, setVideos] = useState(videosList);
  const [currentVideo, setCurrentVideo] = useState(false); // To store the currently playing video
  const [activeOption, setActiveOption] = useState("All");
  const [filteredVideos, setFilteredVideos] = useState(videos);
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const clickedPlaylist = (videos) => {
    setVideos(playLists[videos.id]);
    setActiveOption(activeOption);
    document.getElementById('scroll-video-container').scrollIntoView({ behavior: 'smooth' });
  };
  const closeIframe = () => {
    setCurrentVideo(null); // Close the iframe
  };

  const setCurrentVideoToPlay = (video) => {
    setCurrentVideo(video);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleOptionClick = (option) => {
    setActiveOption(option);
    filterVideosFunc(option);
  };
  const filterVideosFunc = (option) => {
    if (option === "All" || option === "Free Trainings") {
      setFilteredVideos(videos);
    } else if (option === "Featured Trainings") {
      setFilteredVideos(videos.filter((video) => video.countViews > 100)); // Adjust the threshold as needed
    }
  };
  useEffect(() => {
    filterVideosFunc(activeOption);
  }, [videos, activeOption]);
  return (
    <div id={styles.videoContainer}>
      <div className={styles.gradientLeft}></div>
      <div>
        <h1 id={styles.videoTitle}>Video Trainings</h1>
      </div>
      <div>
        <p id={styles.videoDesc}>
          Let’s Learn Something Extraordinary Together 
        </p>
      </div>
      <div id={styles.categoryAndVideosContainer}>
        {isDesktop &&  <VideoCategories clickedPlaylist={clickedPlaylist} />}
        {!isDesktop && <MobileVideoCategory clickedPlaylist={clickedPlaylist}/> }
        <Videos
          videos={videos}
          setVideos={setVideos}
          setCurrentVideo={setCurrentVideoToPlay}
          activeOption={activeOption}
          setActiveOption={setActiveOption}
          handleOptionClick={handleOptionClick}
          filteredVideos={filteredVideos}
          setFilteredVideos={setFilteredVideos}
        />
      </div>
      {currentVideo && (
        <div className={browsevideosstyles.iframeOverlay}>
          <div className={browsevideosstyles.iframeContainer}>
            <iframe
              src={currentVideo.src}
              title={currentVideo.title}
              width="800px"
              height="450px"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <button
              className={browsevideosstyles.closeButton}
              onClick={closeIframe}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {isDesktop && <PremiumCourseBanner />}
    </div>
  );
};

export default Video;
